export default __webpack_public_path__ + "static/media/signal.d241e991.svg";